// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__xEnRW","ant-page-header-heading-title":"styles_ant-page-header-heading-title__ta8Qi","table":"styles_table__mv-wf"};